import { render, staticRenderFns } from "./DoReceiptExpand.vue?vue&type=template&id=7372b264&"
import script from "./DoReceiptExpand.vue?vue&type=script&lang=js&"
export * from "./DoReceiptExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports